import React, {useEffect, useState} from 'react';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import {Swiper, SwiperSlide} from '../../services/ImportsSwiper';
import {ILogoPartner, Props} from './interfaces';
import './SliderLogos.scss';
import './SliderLogos-media.scss';
import {settings, settings2} from './constants';


const SliderLogos = ({title, slidesLogo, logosPartners, padding, widthWindow, parentNode}: Props) => {
  const [logosList, setLogosList] = useState<ILogoPartner[]>([]);
  const [offsetContent, setOffsetContent] = useState(0);

  useEffect(() => {
    if (slidesLogo) {
      setLogosList(slidesLogo);
    } else {
      setLogosList(logosPartners);
    }
  }, [slidesLogo, logosPartners]);

  const [slides, setSlides] = useState<ILogoPartner[][]>([[], []]);
  useEffect(() => {
    const countLogo = logosList.length;
    const lengthHalf = Math.ceil(countLogo / 2);

    if (countLogo < 7) {
      setSlides([logosList.slice(0), []]);
    } else {
      setSlides([logosList.slice(0, lengthHalf), logosList.slice(lengthHalf)]);
    }
  }, [logosList]);

  const [countSlides, setCountSlides] = useState(Math.ceil(widthWindow / 320));
  useEffect(() => {
    if (widthWindow > 720) {
      setCountSlides(Math.ceil(widthWindow / 320));
    } else {
      setCountSlides(Math.ceil(widthWindow / 200));
    }
  }, [widthWindow]);

  const stylePadding = padding ? {padding} : {};
  const stylesBlock = {...stylePadding, transform: `translateX(-${offsetContent}px)`};

  return (
    <>
      {title && <h2 className={'title'} style={{marginBottom: '24px'}}>{title}</h2>}
      <div className="block-logos" style={stylesBlock}>
        <div
          className="block-logos__bg"
          style={{transform: `translateX(${widthWindow >= 1440 ? offsetContent : 0}px)`}}
        ></div>
        {slides[0].length ? (
          <Swiper {...settings} slidesPerView={countSlides} spaceBetween={widthWindow > 720 ? 24 : 8}>
            {slides[0]?.map((logo, i) => (
              <SwiperSlide key={i}>
                <Slide {...logo} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : null}
        {slides[1].length ? (
          <Swiper {...settings2} slidesPerView={countSlides} spaceBetween={widthWindow > 720 ? 24 : 8}>
            {slides[1]?.map((logo, i) => (
              <SwiperSlide key={i}>
                <Slide {...logo} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : null}
      </div>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(SliderLogos));

const Slide = ({image, alt}: ILogoPartner) => (
  <div className="slider-logos__slide">
    <img src={`${image}`} className="slider-logos__logo" alt={alt}></img>
  </div>
);
